/**
 * Round 9 E7 -- the region a native date control reads.
 *
 * `<input type="date">` and `type="datetime-local">` take their segment
 * order from the nearest `lang`, and Chromium maps a BARE "en" to US
 * order: mm/dd/yyyy, under a page whose every other date reads
 * "30 Aug 2026".
 *
 * Round 8 D9 fixed the mapping and applied it to <html>, which every
 * input inherits. This makes it explicit on the controls themselves,
 * for a reason worth writing down rather than dismissing as belt and
 * braces: inheritance is invisible. Nothing on the control says where
 * its format came from, so the next person to add a date input has no
 * way to know the question was already settled, and the seventh round
 * of this finding is what that costs.
 *
 * One helper, so the seventeen controls cannot drift apart.
 */
import { useTranslation } from "react-i18next";

import { documentLangTag } from "shared/i18n";

/** The BCP-47 tag a native date control should format under. */
export function useDateInputLang(): string {
  const { i18n } = useTranslation();
  return documentLangTag(i18n.language);
}
